import $ from "jquery"
class anKangBigData {
  constructor(opt) {
    this.vm = opt.vm
    this.index = 1
    this.mapZoom = null
    this.stop = true
  }
  mouseoverAnKangCity = data => {
    this.stop = false
    this.removeOldButton()
    this.mapZoom = this.vm.chartOption.zoom
    this.createDom(data)
  }
  mouseoutAnKangCity = data => {
    let _this = this
    this.stop = true
    let dom1 = $(".anKangBigDataWrapper")[0]
    dom1.addEventListener("mouseenter", function () {
      _this.stop = false
    })
    dom1.addEventListener("mouseleave", function () {
      _this.stop = true
    })
    setTimeout(()=>{
      if(this.stop){
        this.removeOldButton()
      }
    }, 500)
  }
  removeOldButton(){
    const el = this.vm.$el
    const oldNode = el.getElementsByClassName("anKangBigDataWrapper")[0]
    if (oldNode) el.removeChild(oldNode)
  }
  createDom(mapData) {
    const wrapper = this.createWrapper(mapData)
    this.vm.$el.appendChild(wrapper)
  }
  createWrapper(mapData) {
    const wrapper = document.createElement("a")
    wrapper.className = "anKangBigDataWrapper"
    wrapper.target = "_blank"
    wrapper.innerText = "大数据"
    wrapper.title = mapData.name
    let locX = 0, locY = 0, locLink = 0
    let locationList = [
      {
        id: 1,
        name: '镇坪县',
        x: 390,
        y: 413,
        link: 'https://4723p572.mh.chaoxing.com',
        location: [109.526873,31.883672]
      },
      {
        id: 2,
        name: '平利县',
        x: 353,
        y: 317,
        link: 'https://4723oc52.mh.chaoxing.com',
        location: [ 109.361919,32.389061]
      },
      {
        id: 3,
        name: '岚皋县',
        x: 289,
        y: 411,
        link: 'https://4723o8vq.mh.chaoxing.com',
        location: [108.90229,32.306719]
      },
      {
        id: 4,
        name: '紫阳县',
        x: 205,
        y: 288,
        link: 'https://4723jpxd.mh.chaoxing.com',
        location: [108.534291,32.520209]
      },
      {
        id: 5,
        name: '白河县',
        x: 466,
        y: 234,
        link: 'https://4723ngbw.mh.chaoxing.com',
        location: [110.112608,32.80901]
      },
      {
        id: 6,
        name: '旬阳市',
        x: 369,
        y: 186,
        link: 'https://4723ma1z.mh.chaoxing.com',
        location: [109.361862,32.831913]
      },
      {
        id: 7,
        name: '汉滨区',
        x: 285,
        y: 209,
        link: 'https://4723lbsh.mh.chaoxing.com',
        location: [109.027111,32.696083]
      },
      {
        id: 8,
        name: '汉阴县',
        x: 219,
        y: 193,
        link: 'https://4723ihso.mh.chaoxing.com',
        location: [108.508148,32.892607]
      },
      {
        id: 9,
        name: '石泉县',
        x: 172,
        y: 155,
        link: 'https://4723fv37.mh.chaoxing.com',
        location: [108.248061,33.03805]
      },
      {
        id: 10,
        name: '宁陕县',
        x: 205,
        y: 36,
        link: 'https://47uypj8o.mh.chaoxing.com',
        location: [108.314299, 33.310284]
      },
    ]
    locX = locationList.find(item => item.name === mapData.name).x || 0
    locY = locationList.find(item => item.name === mapData.name).y || 0
    locLink = locationList.find(item => item.name === mapData.name).link || ""
    wrapper.href = locLink

    this.createStyle(wrapper, {
      width: "55px",
      height: "25px",
      position: "absolute",
      top:  locY + "px",
      left: locX + "px",
      color: "#fff",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "25px",
      textAlign: "center",
      background: "linear-gradient(180deg, #F1F3FF 0%, #E98B17 67.45%)",
      borderRadius: "26px",
    })
    return wrapper
  }
  createStyle(dom, style) {
    Object.keys(style).forEach(styleName => {
      dom.style[styleName] = style[styleName]
    })
  }
}

export default {
  data() {
    return {
      anKangBigData: new anKangBigData({
        vm: this
      })
    }
  },
  methods: {
    async anKangBigDataPlugin(opt, self) {

    }
  },
  beforeDestroy() {

  },
  beforeUpdate() {

  }
}
